module.exports = __webpack_public_path__ + "static/BasinBulteni_Catalyst_eng-a1d9c71c64d2b25eff178dc74e423110.png";